module.exports = __webpack_public_path__ + "static/appstore-137fccabd94484a60e7ed6aed738a391.svg";